// extracted by mini-css-extract-plugin
export var close = "Banner-module--close--0P4Cw";
export var link = "Banner-module--link--41PRh";
export var root = "Banner-module--root--yezjy";